import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import jwtDecode from 'jwt-decode';
import { environment } from 'src/environments/environment';


@Injectable()
export class AppService {
  // public static dev_dashboard_url = "https://dev-dashboard.orglensglobal.com/";
  // public   dashboard_url =environment.dashboardURL;
  public dashboard_url = '';

  public parentID: any;
  // public baseURL :string = environment.baseURL;
  public baseURL: string = '';

  env_variables: any = {};
  constructor(
    private httpClient: HttpClient
  ) {
    // if(this.getUrlParameter('prod') == "true"){
    //   console.log("base url")
    //   this.baseURL = "https://app-eu.orglensglobal.com/api/v1/";
    // }
    // if(this.getUrlParameter('dev_1') == "true"){
    //   console.log("base url")
    //   this.baseURL = "https://dev-dashboard.orglensglobal.com/api/v1/";
    // }
    // if(this.getUrlParameter('dev') == "true"){
    //   console.log("base url")
    //   this.baseURL = "https://orglens.org/api/v1/";
    // }


  }

  dbcall(id: any, nteworkName: any): any {
    return this.httpClient.get('http://ec2-35-164-82-153.us-west-2.compute.amazonaws.com/api/cyto_json/' + id + '/' + nteworkName);
  }
  redirectToDashboard() {
    console.log("redirecting to dashboard");
    window.location.replace(this.getEnvVariableValue('dashboardURL'));
  }
  getUrlParameter(sParam: string) {
    var sPageURL = window.location.search.substring(1),
      sURLVariables = sPageURL.split('&'),
      sParameterName,
      i;

    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split('=');

      if (sParameterName[0] === sParam) {
        return sParameterName[1] === undefined ? '' : decodeURIComponent(sParameterName[1]);
      }
    }
    return '';
  };

  // getTableData(id: any): Observable<any> {
  // return this.httpClient.get('http://ec2-100-20-118-156.us-west-2.compute.amazonaws.com/core/fetch_graphlist_data/' + id);

  // }
  getTableData(id: any): Observable<any> {
    return this.httpClient.get('http://ec2-52-41-9-50.us-west-2.compute.amazonaws.com/core/fetch_graphlist_data/' + id);

  }



  getGraph(key: string, fileName: string) {
    var localkey = jwtDecode(key)
    localkey = localkey['study_id'];
    var token = localStorage.getItem('token' + this.getUrlParameter('uid'))
    console.log("token", token);
    //changed by Viraj on 14-04-2023

    // if($("#survey_dd").val()== "pre"){
    //   return  this.httpClient.get("assets/graph_jsons/"+localkey+"/pre/"+fileName+".json")

    // }
    // else if($("#survey_dd").val()== "post"){
    //   return  this.httpClient.get("assets/graph_jsons/"+localkey+"/post/"+fileName+".json")

    // }
    // else if($("#survey_dd").val()== "final"){
    //   return  this.httpClient.get("assets/graph_jsons/"+localkey+"/final/"+fileName+".json")

    // }
    if (this.getUrlParameter('local') == "true") {
      // return this.httpClient.get("assets/graph_jsons/" + localkey + "/" + fileName + ".json")
      return this.httpClient.get("assets/graph_jsons/94/" + fileName + ".json")

    }
    else {
      var headers = new HttpHeaders()
        .set('key', key)
        .set('Content-Type', 'application/json');;
      if (token) {
        console.log("setting auth token");
        headers = headers
          .append('token', token)
      }

      console.log("baseurl ", this.baseURL)
      return this.httpClient.post(this.baseURL + "getjsonasset/" + fileName, "", { headers })    // return this.httpClient.get('http://ec2-52-41-9-50.us-west-2.compute.amazonaws.com/core/get_graph_json/' + key + '/' + fileName);

    }
  }
  live_clients_array = [6, 20, 490, 633, 708, 716, 718, 728, 731, 739, 740]
  getTeamGraph(key: string, fileName: string) {
    var localkey: any = jwtDecode(key)
    localkey = localkey['study_id'];
    var token = localStorage.getItem('token' + this.getUrlParameter('uid'))
    console.log("token", token);
    if (this.getUrlParameter('local') != "true") {
      var headers = new HttpHeaders()
        .set('key', key)
      if (token) {
        console.log("setting auth token");
        headers = headers
          .append('token', token)
      } return this.httpClient.post(this.baseURL + "getjsonasset/" + fileName, "", { headers })
    }

    else {
      if (this.live_clients_array.includes(parseInt(localkey)))
        return this.httpClient.get("assets/graph_jsons/" + localkey + "/" + fileName + ".json")
      else
        return this.httpClient.get("assets/graph_jsons/" + localkey + "/teams/" + fileName + ".json")

    }



    //changed by Viraj on 14-04-2023
    // return this.httpClient.post("https://orglens.in/api/v1/getjsonasset/"+fileName,{key:key})
    // return this.httpClient.get('http://ec2-52-41-9-50.us-west-2.compute.amazonaws.com/core/get_graph_json/' + key + '/' + fileName);
  }
  getIndividualGraph(key: string, fileName: string) {
    var localkey: any = jwtDecode(key)
    localkey = localkey['study_id'];
    var token = localStorage.getItem('token' + this.getUrlParameter('uid'))
    console.log("token", token);
    // if(this.getUrlParameter('new_team_indi_files') == "true" ){
    if (this.getUrlParameter('local') == "true") {
      if (this.live_clients_array.includes(parseInt(localkey)))
        return this.httpClient.get("assets/graph_jsons/" + localkey + "/" + fileName + ".json")
      else
        return this.httpClient.get("assets/graph_jsons/" + localkey + "/ind-graph-jsons/" + fileName + ".json")

    }
    else {
      var headers = new HttpHeaders()
        .set('key', key)
      if (token) {
        console.log("setting auth token");
        headers = headers
          .append('token', token)
      }
      return this.httpClient.post(this.baseURL + "getjsonasset/" + fileName, "", { headers })
    }

    // }
    // else{
    //   return  this.httpClient.get("assets/graph_jsons/"+localkey+"/ind-graph-jsons/"+fileName+".json")

    // }

    //changed by Viraj on 14-04-2023
    // return this.httpClient.post("https://orglens.in/api/v1/getjsonasset/"+fileName,{key:key})
    // return this.httpClient.get('http://ec2-52-41-9-50.us-west-2.compute.amazonaws.com/core/get_graph_json/' + key + '/' + fileName);
  }

  async getConfig_reportJson(key: string) {
    var data = JSON.stringify({ "filename": "config_report" })
    var localkey = jwtDecode(key)
    localkey = localkey['study_id'];
    const headers = new HttpHeaders()
      .set('key', key)
      .set('Content-Type', 'application/json');

    if (this.getUrlParameter('local') == "true") {
      // return await this.httpClient.get("assets/config_jsons/" + localkey + "/config_report.json").toPromise()
return await this.httpClient.get("assets/config_jsons/94/config_report.json").toPromise()
    }
    else {

      console.log("this.baseurl", this.baseURL);
      // console.log("report auth ",this.httpClient.post("https://orglens.org/jwt/authenticate-report/","" ,{headers}).toPromise())
      return await this.httpClient.post(this.baseURL + "getjson/", data, { headers }).toPromise()
    }

  }
  async getGraph_specifications(key: string = '') {

    return await this.httpClient.get("assets/graph_config_specifications.json").toPromise()

    // return await this.httpClient.post(this.baseURL+"getjson/",data ,{headers}).toPromise()
  }
  async getLoginAuth() {
    var key = this.getUrlParameter('uid')

    var token = localStorage.getItem('token' + this.getUrlParameter('uid'))
    console.log("token", token);

    var headers = new HttpHeaders()
      .set('key', key)


    if (token) {
      console.log("setting auth token");
      headers = headers
        .append('token', token)
    }

    return this.httpClient.post(this.dashboard_url + "/jwt/authenticate-report/", "", { headers }).toPromise()

  }

  pushConfig(id: any, config: any) {
    const headers = { headers: new HttpHeaders().set('Content-Type', 'application/json') };
    return this.httpClient.post('http://ec2-100-20-118-156.us-west-2.compute.amazonaws.com/core/process_config_on_demand/' + id, config, headers);
  }

  async getInsightJson(study_id: string, name: string) {
    if (this.getUrlParameter('local') == "true") {

      return await this.httpClient.get('assets/report_v2_files_' + study_id + '/' + name + ".json").toPromise();
    }
    else {
      var key = this.getUrlParameter('uid')
      var token = localStorage.getItem('token' + this.getUrlParameter('uid'))
      console.log("token", token);
      var headers = new HttpHeaders()
        .set('key', key)
      if (token) {
        console.log("setting auth token");
        headers = headers
          .append('token', token)
      }
      return this.httpClient.post(this.baseURL + "getjsonasset/" + name, "", { headers }).toPromise()
    }


  }
  async getv3InsightJson(study_id: string, name: string) {
    if (this.getUrlParameter('local') == "true") {
      return await this.httpClient.get('assets/report_v3_files_' + study_id + '/' + name + ".json").toPromise();

    }
    else {
      var key = this.getUrlParameter('uid')
      var token = localStorage.getItem('token' + this.getUrlParameter('uid'))
      console.log("token", token);
      var headers = new HttpHeaders()
        .set('key', key)
      if (token) {
        console.log("setting auth token");
        headers = headers
          .append('token', token)
      }
      return this.httpClient.post(this.baseURL + "getjsonasset/" + name, "", { headers }).toPromise()
    }


  }
  async generate_layout(formValues: any) {


    var key = this.getUrlParameter('uid')

    const headers = new HttpHeaders()
      .set('key', key)
      .set('Content-Type', 'application/json');;

    console.log('formvalues ', formValues);
    return this.httpClient.post("http://one-tool.ap-southeast-2.elasticbeanstalk.com/api/generate_single_layout_positions/1", formValues, { headers }).toPromise()


  }
  async getGraphMetatdata(fileName:string){
    var key = this.getUrlParameter('uid')
    var localkey = jwtDecode(key)
    localkey = localkey['study_id'];
    var token = localStorage.getItem('token' + this.getUrlParameter('uid'))
    console.log("token", token);
    var headers = new HttpHeaders()
    .set('key', key)
    .set('Content-Type', 'application/json');;
  if (token) {
    console.log("setting auth token");
    headers = headers
      .append('token', token)
  }

  console.log("baseurl ", this.baseURL)
  return await this.httpClient.post(this.baseURL + "getgraphmetadata/" + fileName, "", { headers }).toPromise()    // return this.httpClient.get('http://ec2-52-41-9-50.us-west-2.compute.amazonaws.com/core/get_graph_json/' + key + '/' + fileName);

  }

  async getGraphPositions(name: string, key: string, layout_type: string) {
    var study_id: any = jwtDecode(key)
    study_id = study_id["study_id"]
    if (layout_type == 'Forceatlas2-Noverlap') {
      console.log("Fetching Forceatlas 2")
      // if($("#survey_dd").val()== "pre"){
      //   return await this.httpClient.get('assets/core_'+study_id+'_positions_new/pre/'+name+"_positions.json").toPromise()

      // }
      // if($("#survey_dd").val()== "post"){
      //   return await this.httpClient.get('assets/core_'+study_id+'_positions_new/post/'+name+"_positions.json").toPromise()

      // }
      // if($("#survey_dd").val()== "final"){
      //   return await this.httpClient.get('assets/core_'+study_id+'_positions_new/final/'+name+"_positions.json").toPromise()

      // }
      console.log("positions file name ", name + "_positions")
      var token = localStorage.getItem('token' + this.getUrlParameter('uid'))

      if (this.getUrlParameter('local') != "true") {
        var headers = new HttpHeaders()
          .set('key', key)
        if (token) {
          console.log("setting auth token");
          headers = headers
            .append('token', token)
        }
        return await this.httpClient.post(this.baseURL + "getjsonasset/" + name + "_positions", "", { headers }).toPromise();
      }
      else {

        return await this.httpClient.get('assets/core_94_positions_new/' + name + "_positions.json").toPromise();

      }

    }
    else if (layout_type == "Fruchterman-Reingold") {
      console.log("Fetching Fruchterman Reingold");
      var token = localStorage.getItem('token' + this.getUrlParameter('uid'))

      if (this.getUrlParameter('local') != "true") {
        var headers = new HttpHeaders()
          .set('key', key)
        if (token) {
          console.log("setting auth token");
          headers = headers
            .append('token', token)
        } 
        console.log("frutcherman headers",headers)
        return await this.httpClient.post(this.baseURL + "getjsonasset/" + name + "_positions_fruchterman", "", { headers }).toPromise()
      }
      else {
        return await this.httpClient.get('assets/core_' + study_id + '_positions_new/' + name + "_positions_fruchterman.json").toPromise();

      }

    }
  }

  async getKCore(name: string, study_id: string) {
    return await this.httpClient.get('assets/report_v2_files_' + study_id + '/core-kcore/' + name + "_k_core.json").toPromise();

  }
  privacy_enforced: any = 'false';
  disable_individual_graphs: any = 'false';
  disable_rm_graphs: any = 'false';
  disable_labelling: any = 'false';
  limit_node_info: any = 'false';

  async loadEnvironmentVariables(): Promise<void> {
    try {
      // await (this.httpClient.get<Record<string, string>>('/env-config')).toPromise().then((config)=>{

      // });
      const config = await this.httpClient
        .get<Record<string, string>>('/env-config')
        .toPromise();
      console.log('env config', config);

      this.env_variables = config; // Assign the fetched environment variables

      this.baseURL = this.getEnvVariableValue('baseURL')
      this.dashboard_url = this.getEnvVariableValue('dashboardURL')
      // this.privacy_enforced = this.getEnvVariableValue('privacy_enforced')
      // this.disable_individual_graphs = this.getEnvVariableValue('disable_individual_graphs')
      // this.disable_rm_graphs = this.getEnvVariableValue('disable_rm_graphs')
      // this.disable_labelling = this.getEnvVariableValue('disable_labelling')
      // this.limit_node_info = this.getEnvVariableValue('limit_node_info')

      console.log('baseurl ', this.baseURL)
      console.log('env variables', this.env_variables)
      if (this.getEnvVariableValue('auth_enabled') == "true") {
        const response = await this.getLoginAuth(); // Ensure this returns an Observable.

        console.log('auth status', response);

        if (response["status"] == 0) {
          if (response['payload'])
            localStorage.setItem('token' + this.getUrlParameter('uid'), response['payload'])
        }
        else {
          setTimeout(() => {
           this.redirectToDashboard();
          }, 7000)
        }
      }


    } catch (error) {
      console.error('Failed to load environment variables:', error);
      throw error; // Halt the app initialization if this fails
    }
  }
  getEnvVariableValue(key: string): string | null {
    return this.env_variables[key] || null;
  }



}
